import { DEEPLINK_SCHEME } from './deeplink-scheme';
import { encodeSlug } from './encode-slug';

export function buildCollectionDeeplink(slug: string): string {
  return `${DEEPLINK_SCHEME}collection/${encodeSlug(slug)}`;
}
